import React from "react";

// Sits between the header and the poster-card row: a body-font (Nian)
// quote, framed by a rule above and below it, with the writer's name
// underneath.
function TypingBanner({
  quote = "معماری، پیش از آن‌که هنر باشد، روایتی از نحوهٔ زیستن ماست؛ هر فضا، خاطره‌ای است که هنوز ساخته نشده.",
  author = "روشنک شیخ‌رضایی",
}) {
  return (
    <div className="typing-banner">
      <span className="typing-banner-line" />
      <blockquote className="typing-banner-text">«{quote}»</blockquote>
      <cite className="typing-banner-author">{author}</cite>
      <span className="typing-banner-line" />
    </div>
  );
}

export default TypingBanner;
